import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function ChatMessageComponent(props) {
    return (
        <Fragment>
            {
                props.tipoMensaje === 1 ? (
                    <div className='col-12' style={{ textAlign: 'left !important' }}>
                        <div class="alert alert-primary" style={{ textAlign: 'left' }} role="alert">
                            {props.texto}
                        </div></div>
                )
                    :
                    props.tipoMensaje === 2 ? (
                        <div className='col-12' style={{ textAlign: 'right !important'}}>
                            <div class="alert alert-success" style={{ textAlign: 'right',marginLeft:'30% !important' }} role="alert">
                                {props.texto}
                            </div>
                        </div>
                    )
                        :
                        props.tipoMensaje === 3 ? (
                            <div class="alert alert-secondary" style={{ textAlign: 'center' }} role="alert">
                                {props.texto}
                            </div>
                        )
                            :
                            (
                                <></>
                            )
            }


        </Fragment>
    );
};


export default withRouter(ChatMessageComponent)
